var processInclude = require('core/util');

document.addEventListener("DOMContentLoaded", function() {
    processInclude(require('./components/dataLayer'));
});
